import { graphql } from "../graphql";
import query from "./query.gql";
import { RepoErrorEnum } from "../repo-error.enum";

export async function fetchDeletedOutlets(
  businessId: string
): Promise<Array<IFetchDeletedOutletResponse>> {
  try {
    const response = await graphql.query({
      query,
      variables: {
        businessId,
      },
    });

    return response.data.trashedOutlets;
  } catch {
    throw new Error(RepoErrorEnum.NETWORK_ERROR);
  }
}

interface IFetchDeletedOutletResponse {
  id: string;
  name: string;
}
